import { ScannerPluginWrapperBase } from './abstract-scanner-plugin-wrapper';
import { BarcodeScannerPlugin } from '@paymash/capacitor-barcode-scanner-plugin';
import { PermissionTypes } from '@shared/constants/permission-types.enum';
import { PermissionService } from '@core/services/system/permission/permission.service';
import { IBarcodeScannerPluginSetting } from '@core/services/system/camera-scanner-adapter/wrappers/model';
import { Injectable } from '@angular/core';
import { filter, Subscription } from 'rxjs';

@Injectable()
export class PaymashScannerPluginWrapper extends ScannerPluginWrapperBase {
  private plugin = BarcodeScannerPlugin;
  private subs = new Subscription();
  constructor(private readonly permissionService: PermissionService) {
    super();
  }

  startScan(options: IBarcodeScannerPluginSetting) {
    void this.stopScan();
    this.subs.add(this.plugin
      .startScan({
        rect: {
          x: options.x,
          y: options.y,
          width: options.width,
          height: options.height,
        },
      })
      .pipe(filter((result) => !!result?.value))
      .subscribe({
        next: (result) => this.onResult({ code: result.value }),
        error: (error) => this.onError(error),
      }));
    return Promise.resolve();
  }

  stopScan(): Promise<void> {
    this.subs.unsubscribe();
    this.subs = new Subscription();
    return Promise.resolve();
  }

  checkPermission() {
    return this.permissionService.checkAndRequestPermission(PermissionTypes.CAMERA);
  }
}
